<template>
  <footer class="footer" ref="footer_ele">
    <div class="footer-container lr-page-container">
      <div class="footer-links">
        <dl class="production-download-dl">
          <dt>产品下载</dt>
          <div class="production-download-wrapper">
            <dd class="production-download"
                v-for="(item, index) in links"
                v-show="item.type === 2"
                :key="item.name"
                :class="{ 'download-item': index == lastDownLoadIndex }"
            >
              <lr-link
                :to="item.url"
                :target="item.target"
                :data-name="item.name"
                @click="handleItemClick(item.name)"
                >
                <div class="production-image">
                  <img :src="item.image" alt="">
                </div>
                <span class="production-name">{{ item.name }}</span>
              </lr-link>
            </dd>
          </div>
        </dl>
        <dl>
          <dt>快速通道</dt>
          <dd v-for="item in links" v-show="item.type === 3" :key="item.name">
            <lr-link
              :to="item.url"
              :target="item.target"
              :data-name="item.name"
              @click="handleItemClick(item.name)"
              >{{ item.name }}</lr-link
            >
          </dd>
        </dl>
        <dl>
          <dt>友情链接</dt>
          <dd v-for="item in links" v-show="item.type === 1" :key="item.name">
            <lr-link
              :to="item.url"
              :target="item.target"
              :data-name="item.name"
              @click="handleItemClick(item.name)"
              >{{ item.name }}</lr-link
            >
          </dd>
        </dl>

        <dl>
          <dt>WPS学堂官方号</dt>
          <div class="official-account-wrapper">
            <dd class="official-account" v-for="item in officialAccount" :key="item.name">
              <lr-link
                :to="item.url"
                :target="item.target"
                :data-name="item.name"
                @click="handleItemClick(item.name)"
                >
                <div class="official-image">
                  <img v-if="item.type == 'bilibili'" src="~/assets/image/footer/bilibili.svg" alt="">
                  <img v-if="item.type == 'red_book'" src="~/assets/image/footer/red_book.svg" alt="">
                </div>
                {{ item.name }}
              </lr-link>
            </dd>
          </div>
        </dl>

        <div class="footer-scan-code">
          <img class="footer-scan-code-logo" src="~/assets/image/logo.svg" alt="/" />
          <img class="footer-scan-code-qrcode" :src="siteInfo.qrcode_url || qrcode_wechat" alt="微信扫码" />
          <p v-html="$xss(resolveHtml(siteInfo.qrcode_label)) || '微信扫码 手机学习Office技巧'"></p>
        </div>
      </div>
    </div>

    <div class="footer-copy-right">
      <div class="footer-copy-right-inner lr-page-container">
        <p>
        {{ siteInfo.copyright }}
        </p>
        <p>
          {{ siteInfo.site_icp }}
          <template v-if="siteInfo.site_gwa">
            公安备案号：{{ siteInfo.site_gwa }}
          </template>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PageFooter',

  serverCacheKey: ({ updated }) => {
    return updated;
  },

  props: {
    links: {
      type: Array,
      default: () => [],
    },
    siteInfo: {
      type: Object,
      default: () => ({}),
    },
    updated: String,
  },

  data() {
    return {
      qrcode_wechat: require('~/assets/image/icon/wechat.png'),
      officialAccount: [
        {
          name: 'Bilibili',
          type: 'bilibili',
          url: 'https://space.bilibili.com/413228363',
          target: '_blank'
        },
        {
          name: '小红书',
          type: 'red_book',
          url: 'https://www.xiaohongshu.com/user/profile/596e22b55e87e7024201462f',
          target: '_blank'
        }
      ],
      isFooterShow: false
    }
  },

  computed: {
    lastDownLoadIndex() {
      return this.findLastIndex(this.links, item => item.type === 2, this.links);
    }
  },

  methods: {
    handleItemClick(keyword) {
      this.$collect.homepageFooterClick({ keyword });
      this.$collect.footer_click({ click: keyword });
    },
    footerShowReport() {
      const footerOffsetTop = this.$refs['footer_ele'].getBoundingClientRect().top;
      const browserHeight = window.innerHeight;
      if (footerOffsetTop <= browserHeight && !this.isFooterShow) {
        // 保证只触发一次，避免滚动过程中重复上报
        this.isFooterShow = true;
        this.$collect.footer_show({ show: 'show' });
      }
    },
    findLastIndex(arr, callback, thisArg) {
      for (let index = arr.length - 1; index >= 0; index--) {
        const value = arr[index];
        if (callback.call(thisArg, value, index, arr)) {
          return index;
        }
      }
      return -1;
    },
    resolveHtml(str) {
      return str && str.replace('<br>', ' ')
    }
  },

  mounted() {
    this.footerShowReport();
    this.$eventBus.$on('@change_scroll', this.footerShowReport);
  },

  destroyed() {
    this.isFooterShow = false;
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background: #333840;

  &-container {
    position: relative;
    display: flex;
  }

  &-links {
    padding: 40px 0;
    display: flex;
    flex: 1;

    dl {
      // width: 260px;
      margin-right: 110px;

      &:nth-last-child(2) {
        margin-right: 0;
      }
    }

    dt {
      margin-bottom: 24px;
      font-size: 16px;
      font-weight: 400;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 24px;
    }

    dd {
      margin-bottom: 10px;
      > a {
        font-size: 12px;
        line-height: 16px;
        color: rgba(245, 249, 255, 0.4);

        &:hover {
          color: rgba(245, 249, 255, 0.8);
        }
      }
    }
  }

  &-scan-code {
    flex: 1;
    @include flex-center();
    flex-direction: column;
    align-items: flex-end;
    margin-right: 12px;

    &-qrcode {
      width: 140px;
      height: 140px;
      background: #6D7582;
      border-radius: 8px;
    }

    > p {
      margin-top: 10px;
      font-size: 12px;
      color: rgba(245, 249, 255, 0.4);
      text-align: center;
    }

    &-logo {
      width: 114px;
      height: 29px;
      margin-bottom: 27px;
    }
  }

  &-copy-right {
    text-align: center;
    background: #292D34;
    padding: 26px 0;

    &-inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      > p {
        font-size: 12px;
        line-height: 20px;
        color: rgba(245, 249, 255, 0.4);
      }
    }
  }

  .production-download-wrapper,
  .official-account-wrapper {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    .production-download,
    .official-account {
      // margin-right: 35px;
      margin-bottom: 34px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;

      > a {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      &:hover {
        .production-image,
        .official-image {
           background: rgba(224, 235, 255, 0.08);
           img {
             opacity: 1;
           }
        }
      }
    }

    .production-download {
      width: 90px;
      height: 90px;
      text-align: center;
      margin-bottom: 2px;

      > a {
        .production-name {
          width: 90px;
          word-break: break-all;
        }
      }
    }

    .production-image,
    .official-image {
      width: 40px;
      height: 40px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 6px;

      > img {
        width: 24px;
        height: 24px;
        opacity: 0.4;
      }
    }

    .official-image {
      > img {
        width: 40px;
        height: 40px;
      }
    }
  }

  .production-download-wrapper {
    max-width: 340px;
  }

  .production-download-dl {
    max-width: 340px;
    margin-right: 110px;

    .download-item {
      margin-right: 0;
      margin-bottom: 0;
    }
  }
}
</style>
